import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

import config from "./config";

firebase.initializeApp(config);

const database = firebase.firestore();

export const db = database;
export const auth = firebase.auth();
export const functions = firebase.functions();



// WEBPACK FOOTER //
// ./src/services/firebase/app.js